import { Pipe, PipeTransform } from '@angular/core';

// Define a generic interface for field operations
export interface GenericFieldOperation<T> {
  name: string;
  value: string;
  supportedFieldTypes?: T[];
}

// Define a generic interface for field schemas
export interface GenericFieldSchema<T> {
  fieldType?: T;
}

@Pipe({
  standalone: true,
  name: 'operationFilter',
})
export class OperationFilterPipe<T, U extends GenericFieldOperation<T>, V extends GenericFieldSchema<T>>
  implements PipeTransform
{
  transform(operations: U[], selectedField: V): U[] {
    if (!operations) {
      return [];
    }
    if (!selectedField) {
      return operations;
    }

    return operations.filter((op) => {
      if (op.supportedFieldTypes?.length && selectedField.fieldType) {
        return op.supportedFieldTypes.includes(selectedField.fieldType);
      }
      return true;
    });
  }
}
